import { render } from "./LoginHeader.vue?vue&type=template&id=37f2fa9c&scoped=true&lang=pug"
import script from "./LoginHeader.vue?vue&type=script&lang=js"
export * from "./LoginHeader.vue?vue&type=script&lang=js"

import "./LoginHeader.vue?vue&type=style&index=0&id=37f2fa9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f2fa9c"]])

export default __exports__